export const SET_SHEETS_VIDEOS_MODAL_BUTTON = "SET_SHEETS_VIDEOS_MODAL_BUTTON";
export const SET_SHOW_SHEETS_ACCUEIL = "SET_SHOW_SHEETS_ACCUEIL";


export const setShowSheetsAccueil = (bool) => ({
    type: SET_SHOW_SHEETS_ACCUEIL,
    bool
});

export const setSheetsVideosModalButton = (bool) => ({
    type: SET_SHEETS_VIDEOS_MODAL_BUTTON,
    bool
});